import { BROWSER_ENTRY_PATH, BROWSER_ENTRY_TARGET_PARAM } from '@griply/types';

export type BrowserEntryLocation = {
  origin: string;
  pathname: string;
  search: string;
};

export type BrowserEntryHistory = {
  state: unknown;
  replaceState: History['replaceState'];
};

const HOME = '/';

// Only a page of this app: a target on another origin would make the entry path an open redirect.
const getEntryTarget = ({ origin, search }: BrowserEntryLocation): string => {
  const target = new URLSearchParams(search).get(BROWSER_ENTRY_TARGET_PARAM);
  if (!target) {
    return HOME;
  }
  try {
    const url = new URL(target, origin);
    if (url.origin !== origin || url.pathname === BROWSER_ENTRY_PATH) {
      return HOME;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return HOME;
  }
};

// A POST entry becomes a GET here, before the router reads the url.
export const applyBrowserEntry = (
  location: BrowserEntryLocation,
  history: BrowserEntryHistory,
): void => {
  if (location.pathname !== BROWSER_ENTRY_PATH) {
    return;
  }
  history.replaceState(history.state, '', getEntryTarget(location));
};
